import { mapLinkableEntityType } from '@api';
import type { ShowEventType as ApiShowEventType } from 'src/api/generated/touring/types';
import { mapShowWithTourType } from '../../../common';
import type { ShowEventType } from '../../types';

export const mapShowEventType = (api: ApiShowEventType): ShowEventType => ({
  show: mapShowWithTourType(api.show),
  tourProd: api.tourProd ? mapLinkableEntityType(api.tourProd) : null,
  tourRep: api.tourRep ? mapLinkableEntityType(api.tourRep) : null,
  tourAcc: api.tourAcc ? mapLinkableEntityType(api.tourAcc) : null,
  tourSec: api.tourSec ? mapLinkableEntityType(api.tourSec) : null,
  tourVip: api.tourVip ? mapLinkableEntityType(api.tourVip) : null,
  coPro: api.coPro ? mapLinkableEntityType(api.coPro) : null,
});
